// extracted by mini-css-extract-plugin
export var cdBundleModalArrow = "bundle-modal-module--cd-bundle-modal-arrow--78db0";
export var cdBundleModalArrowLeft = "bundle-modal-module--cd-bundle-modal-arrow-left--1dedd";
export var cdBundleModalArrowRight = "bundle-modal-module--cd-bundle-modal-arrow-right--265dd";
export var cdBundleModalContainer = "bundle-modal-module--cd-bundle-modal-container--f2c0e";
export var cdBundleModalContent = "bundle-modal-module--cd-bundle-modal-content--88909";
export var cdBundleModalDesc = "bundle-modal-module--cd-bundle-modal-desc--deb1e";
export var cdBundleSwiper = "bundle-modal-module--cd-bundle-swiper--aa25a";
export var cdBundleSwiperImg = "bundle-modal-module--cd-bundle-swiper-img--65b90";
export var cdBundleSwiperWrapper = "bundle-modal-module--cd-bundle-swiper-wrapper--f5f65";
export var cdReadMoreButton = "bundle-modal-module--cd-read-more-button--53dd7";